// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"8fbc37c0","486":"8fbc37c0","931":"8fbc37c0"}[chunkId] + ".chunk.css";
};